const foodcomment = {
  add: 'foodcomment/add-by-admin',
  getlist: 'foodcomment/getlist-by-admin',
  update: 'foodcomment/update',
  remove: 'foodcomment/remove',
  get: 'foodcomment/get',
}
export default foodcomment
